module.exports = __webpack_public_path__ + "img/csv-file.ec0ce5db.svg";